export default "__VITE_ASSET__DG9vj_D$__"